import React from 'react';
import Card from 'src/components/Card';
import Avatar from 'src/components/Avatar';
import SrDetailContact from 'src/pages/ServiceRequest/components/SrDetailContact/SrDetailContact';
import OpenContactLink from 'src/components/OpenContactLink/OpenContactLink';
import './ServiceRequestReporterCard.scss';

interface ServiceRequestReporterCardProps {
  serviceRequest: any;
  loading?: boolean;
  canOpenContact: boolean;
}

const ServiceRequestReporterCard = ({
  serviceRequest,
  loading,
  canOpenContact,
}: ServiceRequestReporterCardProps) => {
  if (loading) {
    return (
      <Card
        title="Reporter"
        body={
          <div className="sr-detail-card-row">
            <SrDetailContact loading name={undefined} />
          </div>
        }
      />
    );
  }

  return (
    <Card
      title="Reporter"
      body={
        <div className="sr-detail-card-row">
          <SrDetailContact
            name={serviceRequest.reporter.name}
            role={serviceRequest.reporter.role}
            email={serviceRequest.reporter.email}
            phone={serviceRequest.reporter.phone}
            avatar={
              <Avatar
                url={serviceRequest.reporter.profileImage}
                badge={undefined}
                size={undefined}
              />
            }
          />
          {canOpenContact && serviceRequest.reporter.id && (
            <OpenContactLink
              userId={serviceRequest.reporter.id}
              name={serviceRequest.reporter.name}
              navOrigin={{
                kind: 'serviceRequest',
                serviceRequestId: serviceRequest.id,
              }}
            />
          )}
        </div>
      }
    />
  );
};

export default ServiceRequestReporterCard;